import {useEffect} from 'react';
import { Drawer, DrawerOverlay, DrawerContent, DrawerHeader, DrawerBody} from '@chakra-ui/react'
import KlaonicaView from './KlaonicaView';

const KlaonicaControl = ({klaonica, readonly, onCloseControl, onSave}) => {
   
    // useEffect(() => {
    //     onOpen();
    // }, []);
    // const Close=(e)=>{
    //     onCloseControl();
    //     onClose();
    // }
    return (
        <Drawer placement='right' size={'xl'} onClose={onCloseControl} isOpen={true}>
             <DrawerOverlay/>
                <DrawerContent roundedTopLeft={'md'}>
                    <DrawerHeader pt='5px' roundedTopLeft={'md'} h={'40px'} color={'white'}  bg={'grunt2.700'}>
                        Klaonica
                    </DrawerHeader>
                    <DrawerBody>
                            <KlaonicaView klaonica={klaonica} readonly={readonly} onCancel={onCloseControl} onSave={onSave}/>
                    </DrawerBody>
                </DrawerContent>
        </Drawer>
        
            
        
    );
}

export default KlaonicaControl;
